"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.youtube = void 0;
var youtube = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
    },
    "children": []
  }, {
    "name": "polygon",
    "attribs": {
      "points": "9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
    },
    "children": []
  }],
  "attribs": {
    "fill": "none",
    "stroke": "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }
};
exports.youtube = youtube;